import React from "react";
import { Button, Space } from "antd";

export const getGroupsColumns = (onViewDetails) => [
  {
    title:"Name",
    dataIndex: "groupName",
    key: "name",
    align: "left",
    width: 350,
    render: (name) => <Space>{name}</Space>,
  },
  {
    title: "Created By",
    dataIndex: "creatorName",
    key: "createdBy",
    align: "center",
  },
  {
    title: "Members",
    dataIndex: "memberCount",
    key: "memberCount",
    align: "center",
  },
  {
    title: <div className="pr-12 text-right">Action</div>,
    key: "action",
    align: "right",
    width: 100,
    onCell: () => ({ className: "text-right pr-12" }),
    render: (_, record) => (
      <Button
        type="link"
        className="!text-[rgba(145,14,17,1)] underline"
        onClick={() => onViewDetails(record.groupId, record.groupName)}
      >
        View Details
      </Button>
    ),
  },
];